import {
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { cloneDeep } from 'lodash';
import { AND, EQUAL } from '../../services/query-keys';
import { LabelUI } from './../../models/label.model';
import { FilterService } from './../../services/filter.service';



export class LabelsComponent {
  private _labels: LabelUI[] = [];

   set labelInput(labels: LabelUI[]) {
    this._labels = labels.filter(label => {
      return label.backgroundColor &&
      label.textColor;
    });
  }
   truncateAfter: number;
   allowDelete: boolean;
   context: string = '';
   readonly onLabelClick = new EventEmitter();
   readonly onRemoveLabel = new EventEmitter();

  private labels: LabelUI[] = [];
  private showMore: boolean = false;
  private queryParams: any;

  constructor(
    private route: ActivatedRoute,
    private filterService: FilterService
  ) {}

  moreClick(event) {
    event.stopPropagation();
  }

  clickLabel(label, event) {
    event.stopPropagation();
    this.onLabelClick.emit(label);
  }

  removeLabel(label, event) {
    event.stopPropagation();
    this.onRemoveLabel.emit(label);
  }

  constructQueryExpression(labelId) {
   this.queryParams = cloneDeep(this.route.snapshot.queryParams);
   let showTree: boolean = this.queryParams.hasOwnProperty('showTree');
   let showCompleted: boolean = this.queryParams.hasOwnProperty('showCompleted');
   const newQuery = this.filterService.queryBuilder(
      'label',
      EQUAL,
      labelId
    );
    let existingQuery = {};
    if (this.queryParams.hasOwnProperty('q')) {
      existingQuery = this.filterService.queryToJson(this.queryParams['q']);
    }
    const finalQuery = this.filterService.jsonToQuery(
      this.filterService.queryJoiner(
        existingQuery,
        AND,
        newQuery
      )
    );
    this.queryParams['q'] = finalQuery;
    return this.queryParams;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'f8-label',
  templateUrl: './labels.component.html',
  styleUrls: ['./labels.component.less']
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ActivatedRoute, },
{type: FilterService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'labelInput': [{ type: Input, args: ['labels', ] },],
'truncateAfter': [{ type: Input },],
'allowDelete': [{ type: Input },],
'context': [{ type: Input },],
'onLabelClick': [{ type: Output },],
'onRemoveLabel': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
